import { type PropsWithChildren } from 'react';

import {
  type DataTestId,
  type StylingProps,
} from '@dynatrace/strato-components/core';

//#region Typings
/**
 * Accepted properties for the Select Prefix
 * @public
 */
export type SelectV2PrefixProps = PropsWithChildren<unknown> &
  StylingProps &
  DataTestId;
//#endregion

/**
 * The `SelectV2.Prefix` component allows you to specify any content, that should
 * be prefixed in the trigger element. The `SelectV2.Prefix` component is only valid
 * within the `SelectV2.Trigger` and `SelectV2.Option` element.
 * @example
 * ```tsx
 * <SelectV2.DisplayValue>
 *   <SelectV2.Prefix>
 *     <WhatsNewIcon />
 *   </SelectV2.Prefix>
 * </SelectV2.DisplayValue>
 * ```
 * @public
 */
export function SelectV2Prefix(props: SelectV2PrefixProps): null {
  return null;
}
